import * as Sentry from "@sentry/react";
import { Severity } from "@sentry/react";

import {
  isTestingEnv,
  isProductionEnv,
  isPreProductionEnv,
  isDevelopmentEnv,
} from "./environment";

function getSeverity(level) {
  switch (level) {
    case "debug":
      return Severity.Debug;
    case "error":
      return Severity.Error;
    case "info":
      return Severity.Info;
    case "warn":
      return Severity.Warning;
    default:
      return Severity.Log;
  }
}

const propertyNameProcessor = (key, value) => {
  const keysToMask = ["password", "pword", "pwd", "salary", "credentials"];

  if (keysToMask.some((k) => new RegExp(k, "i").test(key))) {
    return "REDACTED";
  }
  if (typeof value === "string" && value.length > 5000) {
    return `String(${value.length} length)`;
  }
  if (value && typeof value === "object" && Object.keys(value).length > 50) {
    return `Object(keys: ${Object.keys(value).length})`;
  }
  return value;
};

export function stringifyPayload(payload) {
  return JSON.stringify(payload, propertyNameProcessor);
}

function formatMessage({
  payload,
  type,
  context,
  layer,
  level,
  exception,
  message,
  severity,
}) {
  const msgArgs = [];
  if (layer) msgArgs.push(`LAYER: ${layer}`);
  if (context) msgArgs.push(`CONTEXT: ${context}`);
  if (type) msgArgs.push(`TYPE: ${type}`);
  if (message) msgArgs.push(`MSG: ${message}`);
  if (payload) msgArgs.push(`PAYLOAD: ${stringifyPayload(payload)}`);
  if (level === "error" && severity) msgArgs.push(`SEVERITY: ${severity}`);
  if (level === "error" && exception)
    msgArgs.push(`EXCEPTION: ${stringifyPayload(exception)}`);
  const finalMessage = msgArgs.join(" | ");
  return level ? `${level.toUpperCase()} --> ${finalMessage}` : finalMessage;
}

export function cobeeLog(args) {
  if (isTestingEnv()) {
    return;
  }
  const { type, context, payload, message, layer, exception } = args;
  let level = args.level ? args.level : "log";
  level = exception ? "error" : level;
  const severity = getSeverity(level);
  const msg = formatMessage({
    type,
    context,
    level,
    payload,
    message,
    layer,
    exception,
    severity,
  });

  if (isDevelopmentEnv && exception) {
    // eslint-disable-next-line no-console
    console.error("ERROR: ", msg);
  }

  if (isProductionEnv() || isPreProductionEnv()) {
    try {
      Sentry.configureScope((scope) => {
        scope.setLevel(severity);
      });

      Sentry.addBreadcrumb({
        category: layer,
        message,
        type,
        data: {
          type,
          level,
          payload: propertyNameProcessor(payload),
          message,
          context,
          layer,
          severity,
          exception,
        },
      });
      if (exception) Sentry.captureException(exception);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("ERROR WHILE LOGGING -->", msg);
    }
  }
}

export function logError(
  error,
  message = undefined,
  levelLog = Severity.Error
) {
  if (isProductionEnv() || isPreProductionEnv()) {
    Sentry.configureScope((scope) => {
      scope.setLevel(levelLog);
    });

    if (message) {
      Sentry.addBreadcrumb({
        category: "error message",
        message,
      });
    }

    Sentry.captureException(error);
  } else {
    // console.log(message);
    // console.error(error);
  }
}

export function addContextLog(category, message, type = "", payload = {}) {
  if (isProductionEnv() || isPreProductionEnv()) {
    Sentry.configureScope((scope) => {
      scope.setLevel(Severity.Log);
    });

    Sentry.addBreadcrumb({
      category,
      message,
      data: {
        type,
        payload,
      },
    });
  } else {
    // console.log(message);
    // console.log(payload);
  }
}
